import { render, staticRenderFns } from "./goodCashierCategory.vue?vue&type=template&id=ecd439b4&scoped=true"
import script from "./goodCashierCategory.vue?vue&type=script&lang=js"
export * from "./goodCashierCategory.vue?vue&type=script&lang=js"
import style0 from "./goodCashierCategory.vue?vue&type=style&index=0&id=ecd439b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd439b4",
  null
  
)

export default component.exports